const generateGroups = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        generatingGroups: true,
      };
    case 'success':
    case 'error':
      return {
        ...state,
        generateGroupsDialogOpenFor: null,
        generatingGroups: false,
      };
    default:
      return state;
  }
};

export default generateGroups;
